// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2DT-M","description":"PatientConsentPreview_description__2P7Rq"};